// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__qm02Z","description":"Hero_description__dHUk+","title":"Hero_title__--w+6","name":"Hero_name__JlrBc","slogan":"Hero_slogan__4Evmz","prueba":"Hero_prueba__2BpjI"};